import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AcceleratorCourseFeedback } from '../accelerator-course-feedback-view.part';

export function getColumns(util: UtilityService) {

	const columns: GridColumn<AcceleratorCourseFeedback, unknown>[] = [
		buildColumn(util, 'Id', row => row.courseVersionId, { header: 'CourseVersionId' }),
		buildColumn(util, 'Text', row => row.courseTitle, { header: 'Course', group: { order: 1, dir: 'asc' } }),
		buildColumn(util, 'Id', row => row.courseLevelId, { header: 'CourseLevelId' }),
		buildColumn(util, 'Text', row => row.courseLevelTitle, { header: 'Section', group: { order: 2, dir: 'asc' } }),
		buildColumn(util, 'Id', row => row.accId, { header: 'AccId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'Accelerator' }),
		buildColumn(util, 'Number', row => row.feedbackRating, { header: 'Rating' }),
		buildColumn(util, 'Text', row => row.comments, { header: 'Comments' }),
	];
	return columns;
}
